import { render } from "./JsonFormatter.vue?vue&type=template&id=79daf898&scoped=true"
import script from "./JsonFormatter.vue?vue&type=script&lang=js"
export * from "./JsonFormatter.vue?vue&type=script&lang=js"

import "./JsonFormatter.vue?vue&type=style&index=0&id=79daf898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79daf898"]])

export default __exports__